<!--confirm弹窗-->
<template>
  <ModalCommon ref="ModalCommon" :title="config.title">
    <div class="wrap">
      <div class="content">
        <div class="inner" :style="{color:  $MainWrap.textColorLevel2}" v-html="config.content"></div>
      </div>
      <div class="s-btn-wrap">
        <div :style="modalConfirmBtnStyleObj" class="s-btn s-btn-confirm" @click="confirm">{{config.confirmBtnText}}</div>
      </div>
    </div>
  </ModalCommon>

</template>

<script>
import ModalCommon from './ModalCommon.vue'
export default {
  name: 'ModalConfirm',
  components: {
    ModalCommon
  },
  props: {
    title: {
      type: String,
      default: '恭喜获得'
    },
    btnText: {
      type: String,
      default: '开心收下'
    }
  },
  inject: {
    // 由 MainWrap 组件传入
    $MainWrap: {
      default: () => null
    }
  },
  data () {
    return {
      config: {
        title: '提示',
        content: '',
        confirmBtnText: '确定',
        cancelBtnText: '取消',
        onConfirm: () => {},
        onCancel: () => {}
      }
    }
  },
  computed: {
    requestAPI() {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    },
    modalConfirmBtnStyleObj () {
      try {
        return JSON.parse(this.$MainWrap.modalConfirmBtnStyle)
      } catch (e) {
        console.error('modalConfirmBtnStyle 格式错误')
        return {}
      }
    },
    modalCancelBtnStyleObj () {
      try {
        return JSON.parse(this.$MainWrap.modalCancelBtnStyle)
      } catch (e) {
        console.error('modalCancelBtnStyle 格式错误')
        return {}
      }
    }
  },
  async mounted () {
  },
  methods: {
    async open (newsId) {
      this.config = {
        title: '活动规则',
        content: '',
        confirmBtnText: '确定',
        onConfirm: () => {}
      }
      this.requestAPI({
        url: '/api/news/detail',
        method: 'get',
        params: { id: newsId }
      }).then(res => {
        this.config.content = res.content
      }).catch(err => {
        console.error(err)
        this.$message.error(err.msg || '系统错误')
      })
      this.$refs.ModalCommon.open()
    },
    confirm () {
      this.config.onConfirm()
      this.close()
    },
    cancel () {
      this.config.onCancel()
      this.close()
    },
    close () {
      this.$refs.ModalCommon.close()
    }
  }
}
</script>

<style scoped lang="scss">
//@import "../common.scss";
.wrap{
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 40px;
}
.content{
  margin-bottom: 0;
  //height: 380px;
  overflow-y: auto;
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  white-space: pre-wrap;
  .inner{
    display: flex;
    flex-direction: column;
    max-height: 100%;
  }
}
.s-btn-wrap{
  padding: 30px 0 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.s-btn{
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  width: 222px;
  height: 61px;
  line-height: 61px;
  color: #fff;
  margin: 0 20px;
  transition: .3s;
  cursor: pointer;
}
.s-btn-confirm{
  &:hover{
    filter: brightness(1.1);
  }
}
</style>
